import {
    SMS_CREATE,
    SMS_LIST,
    SMS_UPDATE
} from "../actions";

export function sms(currentState = {}, action) {
    switch (action.type) {
        case SMS_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case SMS_LIST:
            return currentState = action
        case SMS_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}